module.exports = __webpack_public_path__ + "img/Lading_1.7a533f34.png";